import { createSlice } from '@reduxjs/toolkit';
import moment from 'moment';

const searchDateFormat = 'DD/MM/YYYY';
const params = new URL(window.location.href).searchParams;

const initialState: any = {
  searchParams: {
    from: null,
    to: null,
    pax:
      params.get('pax') === '' || params.get('pax') === null
        ? null
        : params.get('pax')?.split(','),
    rooms:
      params.get('rooms') === '' || params.get('rooms') === null
        ? null
        : params.get('rooms'),
    adult:
      params.get('adult') === '' || params.get('adult') === null
        ? 2
        : params.get('adult'),
    child:
      params.get('child') === '' || params.get('child') === null
        ? 0
        : params.get('child'),
    inf:
      params.get('inf') === '' || params.get('inf') === null
        ? 0
        : params.get('inf'),
    oneWay:
      params.get('oneWay') === '' || params.get('oneWay') === null
        ? '0'
        : params.get('oneWay'),
    vacationType:
      params.get('vacationType') == '' || params.get('vacationType') === null
        ? null
        : params.get('vacationType'),
    destination:
      params.get('destination') === '' || params.get('destination') === null
        ? null
        : params
            .get('destination')?.includes(',') ? 
            params?.get('destination')?.split(',')
            .map((entry) => Number(entry)) : params
            .get('destination'),
    departure:
      params.get('departure') === '' || params.get('departure') === null
        ? null
        : params
            .get('departure')?.includes(',') ? 
            params?.get('departure')?.split(',')
            .map((entry) => Number(entry)) : params
            .get('departure'),
    destinationCity:
      params.get('destinationCity') === '' || params.get('destinationCity') === null
        ? null
        : params
            .get('destinationCity'),
    departureCity:
      params.get('departureCity') === '' || params.get('departureCity') === null
        ? null
        : params
            .get('departureCity'),
    boardBasis:
      params.get('boardBasis') === '' || params.get('boardBasis') === null
        ? null
        : params.get('boardBasis')?.split(','),
        hotelStar:
        params.get('hotelStar') === '' || params.get('hotelStar') === null
          ? null
          : params.get('hotelStar')?.split(','),  },
  searchResults: [],
};

export const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    updateSearchParams: (state, action) => {
      state.searchParams = action.payload;
    },
    updateSearchResults: (state, action) => {
      state.searchResults = action.payload;
    },
    clearSearchParams: (state) => {
      state.searchParams = {
        ...initialState.searchParams,
        pax: null,
        rooms: null,
        vacationType: null,
        destination: null,
        adult: 0,
        child: 0,
        inf: 0,
      };
    },
    updateSearchInitialState: (
      state,
      action: { type: string; payload: { from: number; range: number, destination:string, destinationCity:string, departure:string, departureCity:string  } }
    ) => {
      const currParams = new URL(window.location.href).searchParams;
      let from, to, date;
      if (currParams.get('from')) {
        from = currParams.get('from');
      }
      if (currParams.get('date')) {
        date = currParams.get('date');
      }
      if (currParams.get('to') && from) {
        to = currParams.get('to');
      }
      if (!from) {
        from = moment().add(action.payload.from, 'd').format(searchDateFormat);
      }
      if (!date) {
        date = moment().add(action.payload.from, 'd').format(searchDateFormat);
      }
      if (!to) {
        to = moment()
          .add(action.payload.range + action.payload.from, 'd')
          .format(searchDateFormat);
      }

      if(!state.searchParams.from)state.searchParams.from = from;
      if(!state.searchParams.date)state.searchParams.date = date;
      if(!state.searchParams.to)state.searchParams.to = to;
      if(!state.searchParams.destination)state.searchParams.destination = action.payload.destination;
      if(!state.searchParams.departure)state.searchParams.departure = action.payload.departure;
      if(!state.searchParams.destinationCity)state.searchParams.destinationCity = action.payload.destinationCity;
      if(!state.searchParams.departureCity)state.searchParams.departureCity = action.payload.departureCity;
    },
  },
});

export const {
  updateSearchParams,
  updateSearchResults,
  updateSearchInitialState,
  clearSearchParams,
} = searchSlice.actions;

export default searchSlice.reducer;
